import {
  SUPERPIXEL_CONFIGURATION,
  SUPERPIXEL_CONFIGURATIONS,
  SUPERPIXEL_EVENTS,
} from '@mm/api-routes';
import {
  SuperpixelConfiguration,
  SuperpixelEventsResponse,
} from '@mm/state/model/SuperpixelModel';
import AuthenticatedController from './AuthenticatedController';

export default class SuperpixelConfigurationController extends AuthenticatedController {
  static async fetch(facebookPageId: number): Promise<SuperpixelConfiguration> {
    return super.get(SUPERPIXEL_CONFIGURATIONS(facebookPageId));
  }

  static async update(
    data: Partial<SuperpixelConfiguration> & { id: number },
  ): Promise<SuperpixelConfiguration> {
    return super.put(SUPERPIXEL_CONFIGURATION(data.id), data);
  }

  static async getEvents(
    facebookPageId: number,
    force?: boolean,
  ): Promise<SuperpixelEventsResponse> {
    return super.put(SUPERPIXEL_EVENTS, {
      facebook_page_id: facebookPageId,
      force,
    });
  }
}
